/*
 * MDN newsletter popup — <oi-newsletter-popup> (Réalisation Par-style 2-step flow, 08-04).
 * Markup in sections/oi-newsletter-popup.liquid, shell in assets/oi-nlp.css.
 *
 * Flow (mirrors RP's Klaviyo form UrW2R2):
 *   email step  → POST email to the EMAIL list → sms step
 *   sms step    → phone OPTIONAL: empty "+" skips; else POST email+phone to the SMS list → success
 *   success     → shared thank-you panel
 * The SMS list is NOT set up in the client's Klaviyo yet: while data-sms-list-id is blank the
 * phone step transitions but posts nothing (simulated). Paste the list ID in the section
 * settings to go live — no code change needed.
 * Theme editor (design mode): renders open, and submits only SIMULATE (no network) so the
 * client can click through all three steps while styling.
 */
(function () {
  if (window.customElements && customElements.get('oi-newsletter-popup')) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* Loose E.164 normalization: "+…" kept as-is; 10 digits assumed US (+1); 1+10 digits → +.
     Anything else is rejected with an inline error. */
  function normalizePhone(raw) {
    var v = String(raw || '').trim();
    if (!v) return '';
    if (v.charAt(0) === '+') {
      var e164 = '+' + v.slice(1).replace(/\D/g, '');
      return /^\+\d{8,15}$/.test(e164) ? e164 : null;
    }
    var d = v.replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  class OINewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.modal = this.querySelector('.oi-nlp-modal');
      this.steps = {
        email: this.querySelector('[data-oi-nlp-step="email"]'),
        sms: this.querySelector('[data-oi-nlp-step="sms"]'),
        success: this.querySelector('[data-oi-nlp-step="success"]')
      };
      this.emailForm = this.querySelector('[data-oi-nlp-email-form]');
      this.smsForm = this.querySelector('[data-oi-nlp-sms-form]');
      this.emailInput = this.querySelector('#oi-nlp-email');
      this.phoneInput = this.querySelector('#oi-nlp-phone');
      this.honeypot = this.querySelector('#oi-nlp-hp');

      this.scrollTrigger = parseInt(this.getAttribute('data-scroll-trigger'), 10);
      if (isNaN(this.scrollTrigger)) this.scrollTrigger = 30;
      this.frequency = this.getAttribute('data-frequency') || 'day';
      this.storageKey = this.getAttribute('data-storage-key') || 'oi-nlp';
      this.designMode = this.getAttribute('data-design-mode') === 'true' || !!(window.Shopify && Shopify.designMode);

      this._opened = false;
      this._lastFocus = null;
      this._email = '';

      this._onScroll = this._onScroll.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onOverlayClick = this._onOverlayClick.bind(this);
      this._onEmailSubmit = this._onEmailSubmit.bind(this);
      this._onSmsSubmit = this._onSmsSubmit.bind(this);
      this._onTriggerClick = this._onTriggerClick.bind(this);
    }

    connectedCallback() {
      var closeBtn = this.querySelector('[data-oi-nlp-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      this.addEventListener('click', this._onOverlayClick);
      if (this.emailForm) this.emailForm.addEventListener('submit', this._onEmailSubmit);
      if (this.smsForm) this.smsForm.addEventListener('submit', this._onSmsSubmit);

      // Open from any [data-oi-newsletter] hook (footer "Newsletter" link, etc.)
      this._triggers = Array.prototype.slice.call(document.querySelectorAll('[data-oi-newsletter], a[href="#oi-nlp"], a[href="#klaviyo-popup"]'));
      this._triggers.forEach((el) => el.addEventListener('click', this._onTriggerClick));

      // Theme editor: open only while THIS section is selected in the sidebar (Dawn's pattern for
      // popups), so it doesn't sit over every page being edited. Never gate. (09-28: auto-opening
      // on every editor load + its scroll lock made the editor preview hard to use.)
      if (this.designMode) {
        this._onSectionSelect = (e) => { if (e.target && e.target.contains(this)) this.open(true); };
        this._onSectionDeselect = (e) => { if (e.target && e.target.contains(this)) this.close(); };
        document.addEventListener('shopify:section:select', this._onSectionSelect);
        document.addEventListener('shopify:section:deselect', this._onSectionDeselect);
        return;
      }

      if (this._frequencyAllows()) {
        window.addEventListener('scroll', this._onScroll, { passive: true });
        // Fire once in case the page already loads past the trigger point.
        this._onScroll();
      }
    }

    disconnectedCallback() {
      if (this._onSectionSelect) document.removeEventListener('shopify:section:select', this._onSectionSelect);
      if (this._onSectionDeselect) document.removeEventListener('shopify:section:deselect', this._onSectionDeselect);
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('keydown', this._onKeydown);
      if (this._triggers) this._triggers.forEach((el) => el.removeEventListener('click', this._onTriggerClick));
    }

    /* ---------- frequency gate (localStorage) ---------- */
    _frequencyAllows() {
      if (this.frequency === 'never') return true; // "every page load" testing mode
      var key = this.storageKey + ':' + this.frequency;
      try {
        if (this.frequency === 'session') {
          return sessionStorage.getItem(key) !== '1';
        }
        var last = parseInt(localStorage.getItem(key), 10);
        if (!last) return true;
        var windowMs = this.frequency === 'week' ? 6048e5 : 864e5; // 7d / 1d
        return (Date.now() - last) > windowMs;
      } catch (e) {
        return true; // storage blocked (private mode) — fail open
      }
    }

    _markSeen() {
      var key = this.storageKey + ':' + this.frequency;
      try {
        if (this.frequency === 'session') sessionStorage.setItem(key, '1');
        else localStorage.setItem(key, String(Date.now()));
      } catch (e) { /* ignore */ }
    }

    /* ---------- scroll trigger ---------- */
    _onScroll() {
      if (this._opened) return;
      var doc = document.documentElement;
      var scrollable = (doc.scrollHeight - window.innerHeight);
      var pct = scrollable > 0 ? (window.pageYOffset / scrollable) * 100 : 100;
      if (pct >= this.scrollTrigger) {
        window.removeEventListener('scroll', this._onScroll);
        this.open();
      }
    }

    _onTriggerClick(e) {
      e.preventDefault();
      this.open(true); // explicit open ignores the frequency gate
    }

    /* ---------- open / close ---------- */
    open(force) {
      if (this._opened) return;
      if (!force && !this._frequencyAllows()) return;
      this._opened = true;
      this._lastFocus = document.activeElement;

      this._lockScroll(true);
      this.classList.add('is-open');
      document.addEventListener('keydown', this._onKeydown);

      if (!this.designMode) this._markSeen();

      // focus the email input after the fade settles
      window.setTimeout(() => {
        if (this.emailInput && !this.steps.email.hidden) {
          try { this.emailInput.focus({ preventScroll: true }); } catch (e) { this.emailInput.focus(); }
        }
      }, 380);
    }

    close() {
      if (!this._opened) return;
      this._opened = false;
      this.classList.remove('is-open');
      this._lockScroll(false);
      document.removeEventListener('keydown', this._onKeydown);
      if (this._lastFocus && this._lastFocus.focus) {
        try { this._lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    }

    _onOverlayClick(e) {
      if (e.target === this) this.close(); // scrim click (overlay is the element itself)
    }

    _onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.close();
        return;
      }
      if (e.key === 'Tab') this._trapFocus(e);
    }

    _trapFocus(e) {
      var focusables = this.modal.querySelectorAll(
        'button, [href], input:not([type="hidden"]):not([tabindex="-1"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      focusables = Array.prototype.filter.call(focusables, function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* ---------- scroll lock (preserve position) ---------- */
    _lockScroll(on) {
      if (this.designMode) return; // never freeze the theme editor's preview scrolling
      var html = document.documentElement;
      var body = document.body;
      if (on) {
        this._scrollY = window.pageYOffset;
        html.classList.add('oi-nlp-lock');
        body.classList.add('oi-nlp-lock');
      } else {
        html.classList.remove('oi-nlp-lock');
        body.classList.remove('oi-nlp-lock');
        if (typeof this._scrollY === 'number') window.scrollTo(0, this._scrollY);
      }
    }

    /* ---------- step machine ---------- */
    _showStep(name) {
      Object.keys(this.steps).forEach((key) => {
        if (this.steps[key]) this.steps[key].hidden = key !== name;
      });
      if (name === 'sms' && this.phoneInput) {
        window.setTimeout(() => {
          try { this.phoneInput.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
        }, 80);
      }
    }

    /* ---------- Klaviyo client subscribe ---------- */
    _subscribe(listId, profileAttrs) {
      var companyId = this.getAttribute('data-company-id');
      // Missing ids (or the theme editor) → simulate so the flow never appears broken.
      if (this.designMode || !companyId || !listId) {
        return new Promise((resolve) => window.setTimeout(() => resolve(true), 250));
      }
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          profile: { data: { type: 'profile', attributes: profileAttrs } },
          custom_source: this.getAttribute('data-source') || 'Newsletter Popup'
        }, relationships: { list: { data: { type: 'list', id: listId } } } } })
      }).then((res) => res.ok).catch(() => false);
    }

    /* ---------- step 1: email ---------- */
    _onEmailSubmit(e) {
      e.preventDefault();
      this._clearError(this.emailForm);

      // Honeypot: a filled hidden field = bot. Silently "succeed".
      if (this.honeypot && this.honeypot.value) { this._showStep('success'); return; }

      var email = (this.emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        this._showError(this.emailForm,
          (window.oiNlpStrings && window.oiNlpStrings.invalidEmail) || 'Please enter a valid email address.');
        this.emailInput.focus();
        return;
      }

      this._email = email;
      var btn = this.emailForm.querySelector('.oi-nlp-plus');
      if (btn) btn.disabled = true;

      this._subscribe(this.getAttribute('data-list-id'), { email: email }).then((ok) => {
        if (btn) btn.disabled = false;
        if (ok) {
          this._markSeen(); // subscribed — never re-nag
          this._showStep('sms');
        } else {
          this._showError(this.emailForm,
            (window.oiNlpStrings && window.oiNlpStrings.subscribeError) || 'Something went wrong. Please try again.');
        }
      });
    }

    /* ---------- step 2: optional phone ---------- */
    _onSmsSubmit(e) {
      e.preventDefault();
      this._clearError(this.smsForm);

      var phone = normalizePhone(this.phoneInput ? this.phoneInput.value : '');
      if (phone === '') { this._showStep('success'); return; } // optional — empty "+" skips
      if (phone === null) {
        this._showError(this.smsForm,
          (window.oiNlpStrings && window.oiNlpStrings.invalidPhone) || 'Please enter a valid phone number.');
        this.phoneInput.focus();
        return;
      }

      var btn = this.smsForm.querySelector('.oi-nlp-plus');
      if (btn) btn.disabled = true;

      // Email included so the SMS consent lands on the same Klaviyo profile as step 1.
      var attrs = { phone_number: phone };
      if (this._email) attrs.email = this._email;

      this._subscribe(this.getAttribute('data-sms-list-id'), attrs).then((ok) => {
        if (btn) btn.disabled = false;
        if (ok) {
          this._showStep('success');
        } else {
          this._showError(this.smsForm,
            (window.oiNlpStrings && window.oiNlpStrings.subscribeError) || 'Something went wrong. Please try again.');
        }
      });
    }

    /* ---------- inline errors (per form) ---------- */
    _showError(form, msg) {
      var el = form && form.querySelector('[data-oi-nlp-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }
    _clearError(form) {
      var el = form && form.querySelector('[data-oi-nlp-error]');
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }
  }

  customElements.define('oi-newsletter-popup', OINewsletterPopup);
})();
